import React from 'react';
import {
    formatDropChance,
    rarityLabel,
    rarityTotals,
    type RarityTotal
} from 'app/utils/lootboxRarity';
import LootInterface from 'app/interfaces/LootInterface';

interface Props {
    loot: LootInterface[]
}

const LootboxDetailsRarityBar = ({loot}: Props): React.ReactElement | null => {
    const items = rarityTotals(loot);

    if (items.length === 0) {
        return null;
    }

    return <div className="lootbox-detail__rarity">
        <div className="lootbox-detail__rarity-bar">
            {items.map((item: RarityTotal) => <span
                key={item.rarity}
                className={`lootbox-detail__rarity-segment lootbox-detail__rarity-segment--${item.rarity}`}
                style={{flexGrow: item.chance}}
            />)}
        </div>
        <div className="lootbox-detail__rarity-legend">
            {items.map((item: RarityTotal) => <div
                key={item.rarity}
                className="lootbox-detail__rarity-item"
            >
                <span className={`lootbox-detail__rarity-dot lootbox-detail__rarity-dot--${item.rarity}`}/>
                <span className="lootbox-detail__rarity-name">{rarityLabel(item.rarity)}</span>
                <span className="lootbox-detail__rarity-value">{formatDropChance(item.chance)}</span>
            </div>)}
        </div>
    </div>;
};

export default LootboxDetailsRarityBar;
